<template>
    <v-dialog
        v-model       = "value"
        :max-width    = "width"
        :hide-overlay = "fullScreen"
        :content-class = "contentClass"
        persistent
    >
        <v-card
            :class = "fullScreen ? 'full-screen' : ''"
            style="overflow-y: hidden"
        >
            <f-dialog-title
                :title  = "title"
                :icon   = "icon"
                @cancel = "onCancel"
                v-if    = "showHeader"
            >
                <template v-slot:toolbar>
                    <slot name="toolbar"></slot>
                </template>
            </f-dialog-title>

            <v-card-text
                :class="inset ? 'pa-3 pt-1 pb-1' : 'pa-0 ma-0'"
            >
                <slot name="content" />
            </v-card-text>

            <f-dialog-actions
                v-if          = "!hideActions"
                :store-label  = "storeLabel"
                :delete-label = "deleteLabel"
                :show-delete  = "showDelete"
                :show-save    = "showSave"
                :show-cancel  = "showCancel"
                @cancel       = "onCancel"
                @store        = "onStore"
                @delete       = "onDelete"
            >
                <template v-slot:pre>
                    <slot name="preaction"></slot>
                </template>
            </f-dialog-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import FDialogTitle      from "@/modules/core/components/utils/FDialogTitle";
import FDialogActions from "@/modules/core/components/utils/FDialogActions";

export default {
    name: "FDialog",
    components: {
        FDialogActions,
        FDialogTitle
    },

    props: {
        value: {
            required: true,
            type    : Boolean,
        },

        icon: {
            default: function () {
                return null;
            }
        },

        title: {
            required: false,
        },

        width: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        storeLabel: {
            required: false,
            default : function () {
                return this.$t('common.store');
            }
        },

        deleteLabel: {
            required: false,
            default : function () {
                return this.$t('common.delete');
            }
        },

        fullScreen: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        hideActions: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        showDelete: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        showSave: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        showHeader: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        showCancel: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        contentClass: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        inset: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
    },

    data: () => ({
    }),

    methods: {
        onCancel () {
            this.$emit("cancel");
        },

        onStore () {
            this.$emit("store");
        },

        onDelete () {
            this.$emit("delete");
        }
    }
}
</script>

<style scoped>


.full-screen {
    margin-top: 12px!important;
    height: calc(100% - 25px);
    top: 0;
    left: 75px;
    position: fixed;
    width: calc(100% - 120px)!important;
}
</style>